import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { useEffect } from 'react'
import { Cormorant_Garamond, IBM_Plex_Mono, Newsreader, Questrial } from 'next/font/google'
import { initPreferences } from '@/lib/preferences'
import { PageTransition } from '@/components/generals/page-transition'
import { ReticleCursor } from '@/components/generals/reticle-cursor'
import { DarkAdaptation } from '@/components/generals/dark-adaptation'

const sans = Newsreader({
    subsets: ['latin'],
    style: ['normal', 'italic'],
    axes: ['opsz']
})

const mono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500']
})

const heading = Cormorant_Garamond({
    subsets: ['latin'],
    style: ['normal', 'italic']
})

/** The CosmicLens wordmark face. */
const brand = Questrial({
    subsets: ['latin'],
    weight: ['400']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily};--font-app-brand:${brand.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    useEffect(() => {
        initPreferences()
    }, [])

    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>

            <PageTransition>
                <Component {...pageProps} />
            </PageTransition>

            <DarkAdaptation />
            <ReticleCursor />
        </div>
    )
}

export default App
